export const dataLimitFormat = (
  obj: { units: number; type: string },
  gettext: (key: string) => string,
) => {
  let result;
  if (obj.units > 1) {
    if (obj.type === "year") {
      result = obj.units + " " + gettext("Years");
    } else {
      result = obj.units + " " + gettext("Months");
    }
  } else if (obj.units > 0) {
    if (obj.type === "year") {
      result = obj.units + " " + gettext("Year");
    } else {
      result = obj.units + " " + gettext("Month");
    }
  } else {
    if (obj.type === "year") {
      result = gettext("Current year only");
    } else {
      result = gettext("Current month only");
    }
  }

  return result;
};
